const getTemplateRoot = rootBlockId => ({
  type: { resolvedName: "template_root" },
  displayName: "TemplateRootBlock",
  isCanvas: false,
  hidden: false,
  props: {},
  custom: {},
  nodes: [rootBlockId],
  linkedNodes: {},
})

export function parseDefinition(definition) {
  if (!definition) {
    return null
  }

  const nodes = definition ? Object.entries(definition) : []
  const root = nodes.find(([, node]) => node.parent === null)

  const [rootBlockId] = root

  return {
    ROOT: getTemplateRoot(rootBlockId),
    ...Object.fromEntries(nodes.map(([nodeId, node]) => {
      if (nodeId === rootBlockId) {
        return [nodeId, { ...node, parent: "ROOT" }]
      }
      return [nodeId, node]
    })),
  }
}

export function parseCraft(nodes) {
  const { ROOT, ...blockNodes } = nodes

  if (!ROOT) {
    return {}
  }

  const [rootNodeId] = ROOT.nodes

  const definition = Object.entries(blockNodes).map(([nodeId, node]) => {
    if (nodeId === rootNodeId) {
      return [nodeId, { ...node, parent: null }]
    }
    return [nodeId, node]
  })

  return {
    ...Object.fromEntries(definition),
  }
}

export function getSerializedRootNodeId(nodes) {
  const [rootNodeId] = nodes?.ROOT?.nodes || []
  return rootNodeId || "ROOT"
}
